import React from 'react';
import { Grid, Typography, useTheme } from '@mui/material';
import CropFreeIcon from '@mui/icons-material/CropFree';
import { formatPhoneNumber } from '../../../../utils/user';
import QRCodeComponent from '../../../../components/QRCodeComponent';

const FullWidthStyle = {
  width: '100%'
};

const FirstGridItemStyle = {
  ...FullWidthStyle,
  padding: 24
};

const SecondGridItemStyle = {
  ...FullWidthStyle,
  padding: '12px 16px'
};

const IconStyle = {
  verticalAlign: 'middle'
};

const WhatsappQRCode = props => {
  const { whatsapp, url, qrCodeRef, ...rest } = props;

  const theme = useTheme();

  return (
    <Grid
      container
      {...rest}
      sx={[{
        flexDirection: "column",
        alignItems: "center"
      }, ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx])]}>
      <Grid style={{ ...FirstGridItemStyle, background: theme.palette.primary.main }}>
        <Typography color="textPrimary" component="div">
          <Grid container spacing={1} sx={{
            alignItems: "center"
          }}>
            <Grid>
              <CropFreeIcon style={IconStyle} />
            </Grid>
            {/* <Grid>{formatPhoneNumber(whatsapp)}</Grid> */}
          </Grid>
        </Typography>
      </Grid>
      {url && (
        <Grid style={SecondGridItemStyle}>
          <QRCodeComponent
            content={url}
            logo={true}
            style={{ margin: 0 }}
            imgStyle={{ width: '100%' }}
            ref={qrCodeRef}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default WhatsappQRCode;
